import { render, staticRenderFns } from "./DummyComponent.vue?vue&type=template&id=0da8d268&scoped=true&"
import script from "./DummyComponent.vue?vue&type=script&lang=js&"
export * from "./DummyComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da8d268",
  null
  
)

export default component.exports